import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-6">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">StreamerWars</h3>
            <p className="text-gray-400 text-sm">
              The ultimate platform for competitive streaming and gaming entertainment.
            </p>
          </div>
          
          <div>
            <h4 className="text-md font-medium mb-4">Platform</h4>
            <ul className="space-y-2">
              <li><Link to="/browse" className="text-gray-400 hover:text-white text-sm">Browse</Link></li>
              <li><Link to="/categories" className="text-gray-400 hover:text-white text-sm">Categories</Link></li>
              <li><Link to="/tournaments" className="text-gray-400 hover:text-white text-sm">Tournaments</Link></li>
              <li><Link to="/community" className="text-gray-400 hover:text-white text-sm">Community</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-md font-medium mb-4">Support</h4>
            <ul className="space-y-2">
              <li><Link to="/help" className="text-gray-400 hover:text-white text-sm">Help Center</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white text-sm">Contact Us</Link></li>
              <li><Link to="/rules" className="text-gray-400 hover:text-white text-sm">Rules</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-md font-medium mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/terms" className="text-gray-400 hover:text-white text-sm">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white text-sm">Privacy Policy</Link></li>
              <li><Link to="/cookies" className="text-gray-400 hover:text-white text-sm">Cookie Policy</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} StreamerWars. All rights reserved.
          </p>
          <div className="flex space-x-4">
            <a href="https://twitter.com" className="text-gray-400 hover:text-white" target="_blank" rel="noopener noreferrer">
              Twitter
            </a>
            <a href="https://discord.com" className="text-gray-400 hover:text-white" target="_blank" rel="noopener noreferrer">
              Discord
            </a>
            <a href="https://instagram.com" className="text-gray-400 hover:text-white" target="_blank" rel="noopener noreferrer">
              Instagram
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 